import React, { FunctionComponent, PropsWithChildren } from 'react';
import ReactFocusLock from 'react-focus-lock';
import { ReactFocusLockProps } from 'react-focus-lock/interfaces';

export const FocusLock: FunctionComponent<PropsWithChildren<ReactFocusLockProps>> = (props) => (
  <ReactFocusLock {...props}>{props.children}</ReactFocusLock>
);
